// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BLNt","right":"styles_right___4B4m"};